<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I4qm51/tc-custom/9781590206102.jpg?1734319389420" alt="This image is the cover for the book On the Many Deaths of Amanda Palmer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On the Many Deaths of Amanda Palmer
      </h1>
      <p class="bookDescription body article font2">
        <b>“Strange and clever . . . Some inspired thinking about real issues like the slippery nature of the Internet and relationships between artists and their fans” (<i>Flagpole</i>).</b><br/>  <br/> Centered around the hypothetical death of a real-life musician and performance artist—Amanda Palmer of Dresden Dolls fame—this book imagines the fallout of her demise. Upon hearing news of Amanda’s death, her fans began posting their own writing, artwork, and thoughts onto the Internet, eventually creating their own genre called the Palmeresque. By collecting a selection of these submissions in one place and providing commentary, <i>On the Many Deaths of Amanda Palmer</i> explores issues of authorship, celebrity, popular culture, marketing strategies, the corruption of art, and the essential questions of modern media.<br/>  <br/> “A postmodern Russian nesting doll of realities, complete with poems, charts, and censored text, this book is successful on many levels: creepy and fun when accepted at face value; tantalizing when looked at as evidence in a murder mystery; insightful in its commentary on modern celebrity and culture . . . Coy, engaging, and delightfully imagined.” —<i>Publishers Weekly</i> (starred review)
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rohan Kriwaczek, Richard D. Davenport
      </h2>
      
      <p class="authorDescription body article">Rohan Kriwaczek is a composer, writer, and musician. He has written numerous scores for TV, film, and radio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PENGUIN group
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28b2dd7c